import { computed, defineComponent } from 'vue'

import { CsSecondaryButton } from '@sunrise/components'
import { MsMinus, MsPlus } from '@sunrise/icons'

export default defineComponent({
    name: 'CsInputCounter',
    components: { CsSecondaryButton, MsMinus, MsPlus },
    props: {
        errorMsg: { type: String },
        hasError: { type: Boolean, default: false },
        isDisabled: { type: Boolean, default: false },
        interval: { type: Number, default: 1 },
        label: { type: String, required: true },
        maxValue: { type: Number, default: 99 },
        modelValue: {
            type: Number,
            default: 0,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const fieldValue = computed({
            get: (): number => {
                return props.modelValue
            },
            set: (newValue: number) => {
                emit('update:modelValue', newValue)
            },
        })
        const incrementCounter = (): void => {
            if (fieldValue.value < props.maxValue) {
                fieldValue.value += props.interval
            }
        }
        const decrementCounter = (): void => {
            if (fieldValue.value > 0) {
                fieldValue.value -= props.interval
            }
        }

        return { decrementCounter, incrementCounter, fieldValue }
    },
})
